import React from "react";
import { NativeInvoiceDisplayStatus } from "./getNativeInvoiceDisplayStatus";
import {
    NATIVE_INVOICE_TEMPLATE_WORKSPACE_STEPS,
    NATIVE_INVOICE_WORKSPACE_STEPS,
    type NativeInvoiceWorkspaceStep,
} from "./nativeInvoiceWorkspaceSteps";
import styles from "./NativeInvoiceDrawer.module.scss";

export const STATUS_DOT_CLASS: Record<NativeInvoiceDisplayStatus, string> = {
    draft: styles.statusDotDraft,
    scheduled: styles.statusDotScheduled,
    sent: styles.statusDotSent,
    open: styles.statusDotOpen,
    overdue: styles.statusDotOverdue,
    paid: styles.statusDotPaid,
    void: styles.statusDotVoid,
    uncollectable: styles.statusDotUncollectable,
};

interface Props {
    currentStep: NativeInvoiceWorkspaceStep;
    context?: "invoice" | "template";
    statusLabel?: string;
}

// Horizontal step strip right below the drawer top bar ("Step 1 of 2 · Send
// email"), matching the importer and reconciliation flows. It only reports
// progress: steps advance through the command bar actions, never by clicking
// here. Single-step workflows (templates) still show "Step 1 of 1" so the
// progress bar stays consistent with those other flows.
export const NativeInvoiceStatusBar: React.FC<Props> = ({
    currentStep,
    context = "invoice",
    statusLabel,
}) => {
    const steps =
        context === "template"
            ? NATIVE_INVOICE_TEMPLATE_WORKSPACE_STEPS
            : NATIVE_INVOICE_WORKSPACE_STEPS;

    const stepIndex = steps.findIndex((step) => step.id === currentStep);
    const activeStep = steps[stepIndex] ?? steps[0];

    return (
        <div
            className={styles.pageStatus}
            aria-label={
                context === "invoice" ? "Invoice progress" : "Template progress"
            }
        >
            <span className={styles.pageStatusItem}>
                Step {Math.max(stepIndex, 0) + 1} of {steps.length}
            </span>
            <span className={styles.pageStatusItem}>
                {statusLabel ?? activeStep.statusLabel}
            </span>
        </div>
    );
};
